import Box from "./Box";
import Image from "next/image";
import LozengeButton from "./LozengeButton";
import PropTypes from "prop-types";
import React from "react";
import SmallCircleButton from "./SmallCircleButton";
import Text from "./Text";
import UnderlineButton from "./UnderlineButton";

function AddRemoveItems({
  quantity,
  decrementItem,
  incrementItem,
  addItem,
  removeItemsById,
  item,
}) {
  return (
    <Box
      display={[null, null, null, "flex"]}
      alignItems={[null, null, null, "center"]}
      flexDirection={[null, null, null, quantity > 0 ? "row-reverse" : "row"]}
      justifyContent={[null, null, null, "space-between"]}
      width="100%"
      height={[52, null, null, 47]}
    >
      {quantity > 0 && (
        <Box display="flex" alignItems="center">
          <SmallCircleButton
            testHook="decrement-item"
            onClick={() => {
              decrementItem(item);
            }}
          >
            <Image
              src="/images/minus.svg"
              alt="Minus button"
              height={3}
              width={21}
            />
          </SmallCircleButton>
          <Box
            width={[40, 50, 66, null]}
            py="5px"
            backgroundColor="background"
            display="flex"
            justifyContent="center"
            alignItems="center"
            mx={["5px", null, null, "10px"]}
          >
            <Text
              fontWeight={700}
              fontFamily="bold"
              fontSize={[14, 16, 22, 22]}
            >
              {quantity}
            </Text>
          </Box>
          <SmallCircleButton
            testHook="increment-item"
            onClick={() => {
              incrementItem(item);
            }}
          >
            <Image
              src="/images/plus.svg"
              alt="Plus button"
              height={21}
              width={21}
            />
          </SmallCircleButton>
        </Box>
      )}
      {quantity > 0 ? (
        <Box pt={["6px", null, null, 0]}>
          <UnderlineButton
            onClick={() => {
              removeItemsById(item.id);
            }}
          >
            Remove
          </UnderlineButton>
        </Box>
      ) : (
        <Box height="100%" display="flex" alignItems="center">
          <LozengeButton
            small
            onClick={() => {
              addItem(item);
            }}
          >
            Add
          </LozengeButton>
        </Box>
      )}
    </Box>
  );
}

AddRemoveItems.propTypes = {
  quantity: PropTypes.number.isRequired,
  decrementItem: PropTypes.func.isRequired,
  incrementItem: PropTypes.func.isRequired,
  addItem: PropTypes.func.isRequired,
  removeItemsById: PropTypes.func.isRequired,
  item: PropTypes.shape({ id: PropTypes.string.isRequired }),
};

export default AddRemoveItems;
